import { createRouter, createWebHistory } from "vue-router";

const routes = [
    //首页
    {
        path: "/",
        name: "Home",
        component: () =>
            import ("../pages/Home.vue"),
        meta: {
            keepAlive: true,
            keywords: "上海黄龙,黄龙信息,上海黄龙信息技术,上海黄龙信息技术有限公司,黄龙信息技术,黄龙公司,摩恩博特,科技公司,软件开发,机械臂,产线升级,工业自动化,低功耗物联网,智能板卡,检测算法,轻量型机械臂应用",
        },
    },
    //自研产品
    {
        path: "/selfProduct",
        name: "SelfProduct",
        component: () =>
            import ("../pages/SelfProduct.vue"),
        meta: {
            keepAlive: true,
            keywords: "上海黄龙,黄龙信息,上海黄龙信息技术,上海黄龙信息技术有限公司,黄龙信息技术,黄龙公司,摩恩博特,科技公司,软件开发,机械臂,产线升级,工业自动化,低功耗物联网,智能板卡,检测算法,轻量型机械臂应用",
        },
    },
    // 解决方案
    {
        path: "/programme",
        name: "Programme",
        component: () =>
            import ("../pages/Programme.vue"),
        meta: {
            keepAlive: true,
            keywords: "上海黄龙,黄龙信息,上海黄龙信息技术,上海黄龙信息技术有限公司,黄龙信息技术,黄龙公司,摩恩博特,科技公司,软件开发,机械臂,产线升级,工业自动化,低功耗物联网,智能板卡,检测算法,轻量型机械臂应用",
        },
    },
    // 合作案例
    {
        path: "/cooperate",
        name: "Cooperate",
        component: () =>
            import ("../pages/Cooperate.vue"),
        meta: {
            keepAlive: true,
            keywords: "上海黄龙,黄龙信息,上海黄龙信息技术,上海黄龙信息技术有限公司,黄龙信息技术,黄龙公司,摩恩博特,科技公司,软件开发,机械臂,产线升级,工业自动化,低功耗物联网,智能板卡,检测算法,轻量型机械臂应用",
        },
    },
    // 关于我们
    {
        path: "/about",
        name: "About",
        component: () =>
            import ("../pages/About.vue"),
        meta: {
            keepAlive: true,
            keywords: "上海黄龙,黄龙信息,上海黄龙信息技术,上海黄龙信息技术有限公司,黄龙信息技术,黄龙公司,摩恩博特,科技公司,软件开发,机械臂,产线升级,工业自动化,低功耗物联网,智能板卡,检测算法,轻量型机械臂应用",
        },
    },
    // 详情页面
    {
        path: "/details",
        name: "Details",
        component: () =>
            import ("../pages/Details.vue"),
        props($route) {
            return { id: $route.query.id, source: $route.query.source };
        },
        meta: {
            keepAlive: true,
            keywords: "上海黄龙,黄龙信息,上海黄龙信息技术,上海黄龙信息技术有限公司,黄龙信息技术,黄龙公司,摩恩博特,科技公司,软件开发,机械臂,产线升级,工业自动化,低功耗物联网,智能板卡,检测算法,轻量型机械臂应用",
        },
    },
    // 公司详情
    {
        path: "/companyDetails",
        name: "CompanyDetails",
        component: () =>
            import ("../pages/CompanyDetail.vue"),
        meta: {
            keepAlive: true,
            keywords: "上海黄龙,黄龙信息,上海黄龙信息技术,上海黄龙信息技术有限公司,黄龙信息技术,黄龙公司,摩恩博特,科技公司,软件开发,机械臂,产线升级,工业自动化,低功耗物联网,智能板卡,检测算法,轻量型机械臂应用",
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    //点击浏览器的刷新按钮 回到顶部
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0,
        };
    },
});
//点击浏览器的返回按键 页面回到顶部
router.beforeEach((to, from, next) => {
    console.log(to.query);
    console.log(Object.keys(to.query).length);
    if (to.query && Object.keys(to.query).length > 0) {
        console.log(to, from, next);
        // 如果路由带有参数，直接允许跳转
        next();
    } else {
        // 如果路由没有参数，执行其他操作（例如滚动条位置重置）并允许跳转
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        next();
    }

    // 基础关键词（公司相关）
    const baseKeywords =
        "上海黄龙,黄龙信息,上海黄龙信息技术,上海黄龙信息技术有限公司,黄龙信息技术,黄龙公司,摩恩博特,科技公司,软件开发,机械臂,产线升级,工业自动化,低功耗物联网,智能板卡,检测算法,轻量型机械臂应用";

    // 动态设置meta标签
    const keywords = to.meta.keywords ?
        `${baseKeywords},${to.meta.keywords}` :
        baseKeywords;

    // 更新或创建meta标签
    let metaTag = document.querySelector('meta[name="keywords"]');
    if (!metaTag) {
        metaTag = document.createElement("meta");
        metaTag.name = "keywords";
        document.head.appendChild(metaTag);
    }
    metaTag.content = keywords;
});

export default router;